import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from '../../core/components/FlexContainer';
import { VisualContainer } from '../../core/components/VisualContainer';
import { Contact3DPlayerList } from './Contact3DPlayerList';
export const Contact3DSidebar = (props) => {
    const { padding, chatWindowElement } = props;
    return _jsx(FlexContainer, { flex: { flexBasis: '21.875rem' }, children: _jsxs(VisualContainer, { flex: '1', padding: padding, gap: padding, children: [_jsx(Contact3DPlayerList, {}), chatWindowElement] }) });
};
//# sourceMappingURL=Contact3DSidebar.js.map